const mapNumbers = (items: string[] = []): { label: string }[] => items?.map((value: string) => ({ label: value }));

const checkStoreNumberError = (value: string, options: { label: string }[]) => {
	if (!value) {
		return true;
	}
	return !options.some((option) => option.label === value);
};

const checkAreaNumberError = (value: string[], options: { label: string }[]) => {
	if (!value?.length) {
		return true;
	}
	return !value.some((item) => options.some((option) => option.label === item));
};

const checkIfDmsProvider = (providerName: string | undefined) => {
	if (!providerName) {
		return false;
	}
	return Boolean(providerName);
};

export { checkAreaNumberError, checkIfDmsProvider, checkStoreNumberError, mapNumbers };
